import type { Theme } from '@mui/material/styles';

const SvgIcon = (theme: Theme) => {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeLarge: {
          fontSize: 'inherit',
          height: 32,
          width: 32,
        },
      },
    },
  };
};

export default SvgIcon;
